import { Alert, Button, Grid } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { storage } from '../../config/firebase';
import { AcceptedFilesInterface, DropZoneProps } from './interfaces';

export const DropZone = (props: DropZoneProps) => {
    const [files, setFiles] = useState<File[]>([]);
    const [progress, setProgress] = useState(0);
    const [success, setSuccess] = useState('');
    useEffect(() => {
        setFiles([]);
    }, [props.actualEventId]);
    const {
        maxFiles,
        isSendBtn,
        text,
        text2,
        button1,
        button2,
        loading,
        errorMessage,
        successMessage,
        maxSizeMB,
        acceptedFormat,
        path,
        sendOnDrop,
        customName,
        showMessage,
    } = props;

    const onDrop = useCallback((acceptedFiles: File[]) => {
        setFiles(acceptedFiles);
        if (sendOnDrop && acceptedFiles) uploadfiless(acceptedFiles[0]);
    }, []);

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        maxFiles: maxFiles,
        maxSize: maxSizeMB * 1000000,
        accept: acceptedFormat,
    });
    const uploadfiless = (files: File) => {
        const name = customName ? `${customName}.${files.name.split('.')[1]}` : files.name?.replaceAll(' ', '_');
        const StorageRef = ref(storage, `${path}/${name}`);
        props.setGetImgAddress(`${path}/${name}`);

        const uploadTask = uploadBytesResumable(StorageRef, files);

        uploadTask.on(
            'state_changed',
            (snapshot) => {
                const prog = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                if (showMessage) setProgress(prog);
            },
            (err) => {
                setSuccess(`${errorMessage} ${err}`);
            },
            () => {
                getDownloadURL(uploadTask.snapshot.ref).then(() => {
                    if (showMessage) setSuccess(`${successMessage}`);
                });
            },
        );
    };
    const handleSend = () => {
        if (files.length === 0) return;
        files.forEach((files: File) => {
            uploadfiless(files);
        });
    };

    const setFileName = () => {
        if (!props.actualEventFile) return null;
        const fileId = props.actualEventFile.split('/').length;
        const sourceNames = props.actualEventFile.split('/');
        return sourceNames[fileId - 1];
    };

    return (
        <div className="files">
            <div className="files-box">
                <div className="files-content">
                    <div>
                        <div {...getRootProps()} className="dropzone">
                            <input {...getInputProps()} />
                            <h3 className="dropzone-title">{text}</h3>
                            <p className="dropzone-text">{`${text2} ${maxSizeMB} MB`}</p>
                            <ul className="dropzone-list">
                                {files.map((file: AcceptedFilesInterface, id: number) => (
                                    <li key={id} className="dropzone-text-item">
                                        {file.name} ({(file.size / 1000000).toFixed(2)}MB)
                                    </li>
                                ))}
                            </ul>
                            {isSendBtn ? (
                                <Button className="dropzone-btn" variant="outlined">
                                    {button1}
                                </Button>
                            ) : null}
                        </div>
                        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                            <Grid sx={{ textAlign: 'left' }} item xs={2} sm={4} md={4} className="files-item-grid">
                                <span className="files-item">{setFileName()}</span>
                            </Grid>
                            <Grid item xs={2} sm={4} md={4}>
                                <Button
                                    disabled={files.length === 0}
                                    onClick={() => handleSend()}
                                    variant="contained"
                                    className="files-btn"
                                >
                                    {button2}
                                </Button>
                            </Grid>
                        </Grid>

                        {progress !== 0 && !success ? (
                            <Alert variant="outlined" severity="info" className="dropzone-alert">
                                {loading} {progress}%
                            </Alert>
                        ) : null}
                        {success ? (
                            <Alert variant="outlined" severity="success" className="dropzone-alert">
                                {success}
                            </Alert>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};
